import {BaseContainerModel} from '../base-container.model';
import {app_login_change_email_mobile_number_process_RowClass} from '../../dbschema';

export class AppLoginChangeEmailMobileNumberProcessContainerModel extends BaseContainerModel {
  app_login_change_email_mobile_number_process: app_login_change_email_mobile_number_process_RowClass = new app_login_change_email_mobile_number_process_RowClass();
}
